module.exports = __webpack_public_path__ + "static/media/title_bg_6.62e9e0e0.png";